'use strict';

/* eslint-disable max-lines-per-function, max-params*/
angular.module('webAgro1App').controller('ResumoGlebasCtrl', function($scope, $rootScope,
  $window, OperacoesService, MessagesService, StorageService) {
  const RIGHT_SIDE_ACTIONS = ['addRecommendation', 'recommendations', 'addTask', 'tasks'];
  $scope.operacoesTimeline = [
    { id: 'doenca', descricao: 'Doença' },
    { id: 'inseto', descricao: 'Inseto' },
    { id: 'invasora', descricao: 'Invasora' }
  ];

  const loadResumo = function(params) {
    const httpParams = params;

    OperacoesService.resumoGlebas(httpParams).then(function(result) {
      $scope.propriedadeResumo = result.data;
    }, function() {
      MessagesService.alert('Falha ao consultar resumo geral dos talhões');
    })
      .finally(function() {
        $rootScope.loadingCards = false;
      });
  };

  const getGlebaParams = function(history) {
    return {
      gleba: {
        id: history.id,
        descricao: history.descricao
      }
    };
  };

  const getHttpParams = function(objeto, history) {
    history.gleba = getGlebaParams(history).gleba;
    history.data = moment().format('YYYY-MM-DD');
    return {
      objeto: objeto,
      history: history,
      event: event
    };
  };

  const deactivateSide = function(history, message) {
    const params = getGlebaParams(history);
    if (RIGHT_SIDE_ACTIONS.indexOf($scope.rightSide) >= 0 && ($scope.lastGleba || {}).id !== (params.gleba || {}).id) {
      $scope.$broadcast(`${$scope.rightSide }_close`);
      $rootScope.$broadcast('activeRightSide', { name: message });
    }
  };

  $scope.activeStandDetails = function(alerta, history) {
    deactivateSide(history, 'standSummary');
    $rootScope.$broadcast('activeStandDetails', getHttpParams(alerta, history));
  };

  $scope.activeProdutividadeDetails = function(geral, history) {
    deactivateSide(history, 'produtividadeSummary');
    $rootScope.$broadcast('activeProdutividadeDetails', getHttpParams(geral, history));
  };

  $scope.activeSide = function(message, history) {
    const params = getGlebaParams(history);
    deactivateSide(history, message);
    $scope.lastGleba = params.gleba;
    $rootScope.$broadcast(message, params);
  };

  $scope.$on('resumoGlebas', function(event, params) {
    loadResumo(params);
  });

  $scope.$on('close_resumoGlebas', function() {
    $scope.propriedadeResumo = null;
  });

  // eslint-disable-next-line max-params
  $scope.goToTimeline = function(historico, cultivar, operacao, event) {
    if (event) {
      event.preventDefault();
    }

    StorageService.set(KEY_TIMELINE_FILTERS, {
      gleba_id: historico.id,
      atividade_id: cultivar.cultura_id,
      operacao_id: (operacao || {}).id,
      safra_id: cultivar.safra_id
    });

    $window.open('#!/timeline', '_blank');
  };
});
